import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "TourReportService",
  controller: "tb_tour_report",
};

const methods = [
  "GetPageContentByConditions",
  "GetItemById",
  "DelItem",
  "AddItem",
  "UpdateItem", 
  "GetDataStaticByStationAndTime", 
  "GetDataStaticByStation"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function (data) {
      return this.post(path, data);
    };
  });
};

const TourReportResourcesApi = ZJApi.defineNewApi("TourReportResourcesApi", factory);

export default TourReportResourcesApi;
